import { render } from "./grid-card.vue?vue&type=template&id=029465af&scoped=true"
import script from "./grid-card.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-card.vue?vue&type=script&setup=true&lang=js"

import "./grid-card.vue?vue&type=style&index=0&id=029465af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029465af"],['__file',"src/components/grid-card-component/grid-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "029465af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('029465af', __exports__)) {
    api.reload('029465af', __exports__)
  }
  
  module.hot.accept("./grid-card.vue?vue&type=template&id=029465af&scoped=true", () => {
    api.rerender('029465af', render)
  })

}


export default __exports__